import { render, staticRenderFns } from "./addText.vue?vue&type=template&id=6ea387ba&"
import script from "./addText.vue?vue&type=script&lang=js&"
export * from "./addText.vue?vue&type=script&lang=js&"
import style0 from "./addText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports